import React from 'react';
import { useAdminLanguage } from '../../AdminLanguageContext';
import { translateAdmin } from '../../utils/adminTranslations';

function Header({ title }) {
  const { language } = useAdminLanguage();

  // const userRole = localStorage.getItem('asd'); // Получаем роль из localStorage
  return (
    <header className='system-header'>
      <h1>{translateAdmin(title || 'Дашборд', language)}</h1>
      {/* <div className="user-info">
        <p><AdminText>Пользователь:</AdminText> </p>
        <a href="#"><AdminText>Выход</AdminText></a>
      </div> */}
    </header>
  );
}

export default Header;
